import { useEffect, useState } from "react"
import { getClienteById,postCliente, patchCliente,} from "../../services/ClientesServices"
import { ClientesFormContext } from "./ClientesContext"
import { useNavigate, useParams } from 'react-router-dom';

export const ClientesFormState = ({ children }) => {
    const [report, setReport] = useState({})

    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getClienteByIdData(id)
    }, [id])

    const getClienteByIdData = async (id) => {
        let res = await getClienteById(id)
        
        if (res) setReport(res)
    }

    const postClienteData = async (body) => {
        let res = null;
        try {
                res = await postCliente(body); // Si no hay combo, usar el body original
                
                navigate("/clientes");
            } 
        catch (error) {
            console.error("Error al guardar el artículo:", error);
        }
    };

    const patchClienteData = async (id, body) => {
        const res = await patchCliente(id, body)
        if (res) navigate("/clientes");
    }

    return <ClientesFormContext.Provider value={{
        report,
        postClienteData,
        patchClienteData,
    }} >
        {children}
    </ClientesFormContext.Provider>
}